import React from 'react';
import { Badge, HStack, Icon, Tooltip, Box } from '@chakra-ui/react';
import { FaQuestionCircle } from 'react-icons/fa';
import { SITUACOES, SITUACOES_SITE } from './formato';

// Selo da situacao com (?) explicando o que ela significa.
const StatusComissao = ({ situacao, site = false, sufixo, size = 'sm' }) => {
    const mapa = site ? SITUACOES_SITE : SITUACOES;
    const info = mapa[situacao];
    if (!info) return null;

    return (
        <Tooltip label={info.explicacao} hasArrow placement="top" maxW="300px" fontSize="xs" openDelay={150}>
            <Badge
                colorScheme={info.cor}
                variant="subtle"
                px={2}
                py={size === 'sm' ? 0.5 : 1}
                borderRadius="full"
                textTransform="none"
                fontSize={size === 'sm' ? '11px' : 'xs'}
                fontWeight="semibold"
                cursor="help"
                tabIndex={0}
                aria-label={`${info.label}${sufixo ? ` ${sufixo}` : ''}. ${info.explicacao}`}
                w="fit-content"
            >
                <HStack spacing={1} as="span">
                    <Box as="span">{info.label}{sufixo ? ` ${sufixo}` : ''}</Box>
                    <Icon as={FaQuestionCircle} boxSize="10px" opacity={0.7} />
                </HStack>
            </Badge>
        </Tooltip>
    );
};

export default StatusComissao;
